import type { Action } from 'redux';
import { FLUSH_AUTO_SYNC } from 'admin/constants/actions';
import { AUTO_SYNC_TARGET, SYNC_STATUS } from 'admin/constants/common';
import type { AdminThunkAction } from 'admin/reducers';

export function flushStoryEditorSave(): AdminThunkAction<Action, IBackendBody> {
	return async (dispatch, getState) => {
		await dispatch({
			type: FLUSH_AUTO_SYNC,
			payload: AUTO_SYNC_TARGET.STORY_EDITOR,
		});

		return {
			success: getState().loading.syncStoryStatus !== SYNC_STATUS.FAIL,
		};
	};
}
